import tasksActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';

export const reducers = {
  query: createAsyncRequestReducer(tasksActionTypes.FETCH_TASKS_LIST),
  fetch: createAsyncRequestReducer(tasksActionTypes.FETCH_TASK),
  fetchMinimal: createAsyncRequestReducer(tasksActionTypes.FETCH_TASK_STATE),
  create: createAsyncRequestReducer(tasksActionTypes.CREATE_TASK),
  clone: createAsyncRequestReducer(tasksActionTypes.CLONE_TASK),
  cancel: createAsyncRequestReducer(tasksActionTypes.CANCEL_TASK),
};

export default combineReducers(reducers);
